import { getDocByUID, getDocs } from "shared/prismic";
import { PeoplePage } from "containers/PeoplePage";

export async function getStaticProps({ preview = null, previewData, params }) {
  const doc = await getDocByUID({
    previewData,
    uid: params.uid,
    type: "team_detail",
  });
  return { props: { doc, preview } };
}

export async function getStaticPaths() {
  const pages = await getDocs({ type: "team_detail" });
  const paths = pages.map(({ uid }) => ({ params: { uid } }));
  return { paths, fallback: false };
}

export default PeoplePage;
